import { Card, Alert, AlertTitle, Button } from "@mui/material";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { useAutorizacoes } from "../../../../../hooks/useAutorizacoes";
import { approveEstabelecimento } from "../../../../../services/autorizacao.service";
import { createObservacao } from "../../../../../services/observacao.service";
import { sendEmail } from "../../../../../services/email.service";

import AutorizacaoOptions from "./components/autorizacaoOptions";
import RestricaoOptions from "./components/restricaoOptions";

import FazerObservacoes from "../../../../components/fazerObservacoes.";
import RegisterAccess from "../../../../../utils/registerAccess";
import ButtonLeft from "../../../../../utils/buttonLeft"
// import MessageSuccess from "../../../../../messages/messageSuccess";
import MessageError from "../../../../../messages/messageError";
import { ErrorBar } from "recharts";
import CreateOptionsAutorizacao from "./components/createOptionsAutorizacao";
import CreateOptionsRestricao from "./components/createOptionsRestricao";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";


export default function EmissaoAutorizacaoExercicio({ estabelecimento }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.account.user);
    // const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')

    const [form, setForm] = useState({
        tipoAutorizacao: "",
        restricaoAutorizacao: "Nenhuma"
    });
    const [obs, setObs] = useState("");
    const [load, setLoad] = useState(false);

    const { options, restricoes } = useAutorizacoes(estabelecimento?.tipo?.designacao);

    const handleChange = e =>
        setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleApprove = async () => {
        try {

            setLoad(true);

            await approveEstabelecimento({
                ...form,
                estabelecimentoId: id,
                userId: user._id
            });

            if (obs) {
                await createObservacao({
                    descricao: obs,
                    userId: user._id,
                    estabelecimentoId: id
                });
            }

            if (estabelecimento?.email) {
                await sendEmail({
                    to: estabelecimento.email,
                    subject: 'Estado da solicitação de licenciamento de estabelecimento faramacêutico',
                    html: `<h1>A sua Autorização de Exercício foi emitida com sucesso</h1>
                   
                    <p>
                    Este é um email de acompanhamento da solicitação 
                    de lienciamento do estabelecimento <b> ${estabelecimento?.nome} </b>
                    com o número de entrada <b> ${estabelecimento?.numeroEntrada} </b>
                    que submeteu na <b>ARMED</b> 
                    </p>
                    
                    <p>
                    Informamos que a Autorização de Exercício para estabelecimento <b> ${estabelecimento?.nome} </b> já foi emitida.
                    </p>
        
                    <p><b>Nota:</b> Este e-mail foi gerado automaticamente pela plataforma <b>ARMED</b></p>
             `
                });
            }

            dispatch({
                type: "alert",
                payload: { alert: "Autorização emitida com sucesso." }
            });

            navigate(`/admin/autorizacao-de-exercicio/${id}`);

        } catch (err) {
            // console.error(err);
            setMessageError(ErrorBar.response?.data?.message);
        } finally {
            setLoad(false);
        }
    };

    return (
        <Card sx={{ p: 3 }}>
            <RegisterAccess page={'emissão de autorização'} />
            {/* {messageSuccess && <MessageSuccess message={messageSuccess} />} */}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs
                title={'Emissão de Autorização de Exercício'}
                subtitle={`Estabelecimento: ${estabelecimento?.nome} - ${estabelecimento?.tipo?.designacao}`}
            />

            <Alert severity="info">
                <AlertTitle>Tipo de Autorização</AlertTitle>
            </Alert>

            <CreateOptionsAutorizacao
                empresa={estabelecimento?.empresa?.nome}
                tipoEstabelecimento={estabelecimento?.tipo?.designacao}
            />

            <AutorizacaoOptions
                options={options}
                value={form.tipoAutorizacao}
                onChange={handleChange}
                empresa={estabelecimento?.empresa?.nome}
                tipoEstabelecimento={estabelecimento?.tipo?.designacao}
            />

            <br />
            <br />
            <Alert severity="info">
                <AlertTitle>Restrições</AlertTitle>
            </Alert>

            <CreateOptionsRestricao
                empresa={estabelecimento?.empresa?.nome}
                tipoEstabelecimento={estabelecimento?.tipo?.designacao}
            />

            <RestricaoOptions
                options={restricoes}
                value={form.restricaoAutorizacao}
                onChange={handleChange}
            />

            <FazerObservacoes setObs={setObs} obs={obs} titulo={'(caso seja necessário fazer alguma observação)'} />

            <ButtonLeft
                title={'Confirmar'}
                disabled={!form?.tipoAutorizacao}
                funcao={handleApprove}
                load={load}
            >
                <Button color="error" onClick={() => navigate(`/admin/analise/solicitacao-de-licenciamento/${id}`)} >Cancelar</Button>
            </ButtonLeft>
        </Card>
    );
}
